import { useCookies } from "react-cookie";
import Order from "./Order";
import { useEffect, useState } from "react";
import { orderHistory } from "../../../services/orders";

export default function Orders({ cart, setCart }) {
  const [cookie] = useCookies(["access_token"]);
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    orderHistory(cookie?.access_token).then((res) => setOrders(res));
  }, [cookie]);

  return (
    <>
      <div className="orders">
        {orders.map((order) => {
          return (
            <Order
              key={order.id}
              order={order}
              cart={cart}
              setCart={setCart}
            ></Order>
          );
        })}
      </div>
    </>
  );
}
